import { createSelector } from 'reselect'
import createSortedCardStatusesSelector from 'routes/Board/selectors/createSortedCardStatusesSelector'
import createStatusSelector from '../../../selectors/createStatusSelector'
import * as CardStatusRoles from 'const/CardStatusRoles'

const getCardId = (state, props) => props.cardContext.id

const createFilteredStatusesSelector = (cardStatusesSelector) => createSelector(
  [
    cardStatusesSelector
  ],
  (
    cardStatuses
  ) => {
    return cardStatuses.filter(status => status.role !== CardStatusRoles.NONE)
  }
)

const createLineStatusIdSelector = (cardStatusesSelector, statusSelector) => createSelector(
  [
    cardStatusesSelector,
    statusSelector
  ],
  (
    cardStatuses,
    status
  ) => {
    if (!status) return null

    if (status.role === CardStatusRoles.NONE) {
      const currentIndex = cardStatuses.findIndex(cardStatus => cardStatus.id === status.id)

      for (let i = currentIndex; i >= 0; i--) {
        if (cardStatuses[i].role !== CardStatusRoles.NONE) {
          return cardStatuses[i].id
        }
      }
    }

    return status.id
  }
)

const createLineProgressSelector = (filteredStatusesSelector, lineStatusIdSelector, statusSelector) => createSelector(
  [
    filteredStatusesSelector,
    lineStatusIdSelector,
    statusSelector
  ],
  (
    cardStatuses,
    lineStatusId,
    status
  ) => {
    if (!status) return null

    const selectedIndex = cardStatuses.findIndex(cardStatus => cardStatus.id === lineStatusId)
    const length = cardStatuses.length - 1
    if (lineStatusId !== status.id && selectedIndex < cardStatuses.length - 1) {
      return Math.floor(((selectedIndex + 0.5) / length) * 100)
    } else {
      return Math.floor((selectedIndex / length) * 100)
    }
  }
)

const getCardStatusIds = (state, props) => {
  return state['view-board'].cardStatuses[state['view-board'].cards[props.cardContext.id].boardId].ids
}

export default () => {
  const statusSelector = createStatusSelector(getCardId)
  const sortedCardStatusesSelector = createSortedCardStatusesSelector(getCardStatusIds)
  const filteredStatusesSelector = createFilteredStatusesSelector(sortedCardStatusesSelector)
  const lineStatusIdSelector = createLineStatusIdSelector(sortedCardStatusesSelector, statusSelector)
  const lineProgressSelector = createLineProgressSelector(filteredStatusesSelector, lineStatusIdSelector, statusSelector)

  return createSelector(
    [
      filteredStatusesSelector,
      lineStatusIdSelector,
      lineProgressSelector
    ],
    (
      cardStatuses,
      lineStatusId,
      lineProgress
    ) => ({
      cardStatuses,
      lineStatusId,
      lineProgress
    })
  )
}
